<script setup>
import { useModals } from "@/composables/useModals";

const { openModal } = useModals();
</script>
<template>
	<div class="service-notice">
		<h2 class="service-notice__title profile-title">Уважаемые участники Greenfield Club!</h2>
		<div class="service-notice__text">
			<p>Из-за сбоя в&nbsp;работе облачного провайдера Яндекс некоторые функции сайта временно недоступны.</p>
			<p>Мы работаем над их восстановлением. Обмен баллов на&nbsp;подарки возобновится после исправления в&nbsp;сервисах Яндекса. Об&nbsp;этом мы вас уведомим дополнительно сообщением на&nbsp;сайте. Сроки пока неизвестны.</p>
			<p>Если у&nbsp;Вас возникли вопросы, обратитесь, пожалуйста, в&nbsp;службу поддержки.</p>
		</div>
		<button class="service-notice__btn btn --small" type="button" @click="openModal('feedback')">Связаться с поддержкой</button>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

// в макете у текстов обрезка до высоты прописных (leading trim: cap height),
// поэтому вертикальные отступы пересчитаны от строк браузера; 1px — рамка
.service-notice {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 3.52rem 4rem 4rem;
	border: 1px solid var(--border-accent-2-3);
	border-radius: 4rem;
	background: linear-gradient(143deg, #165230 0%, #0b2e1b 100%);
	backdrop-filter: blur(15.399999618530273px);
	box-shadow: inset 0 13px 35px 0 rgba(255, 255, 255, 0.14), 0 16px 33px 0 rgba(0, 0, 0, 0.25);
	@media (max-width: vars.$x480) {
		align-items: stretch;
		padding: 2.65rem calc(2.4rem - 1px) calc(2.4rem - 1px);
		border-radius: 2.4rem;
	}
}

.service-notice__title {
	margin-bottom: 1.4rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 0.75rem;
	}
}

.service-notice__text {
	display: flex;
	flex-direction: column;
	gap: 1.92rem;
	max-width: 95.7rem;
	margin-bottom: 1.88rem;
	font-weight: 500;
	font-size: 1.6rem;
	line-height: 120%;
	color: var(--text-inverse-100);
	@media (max-width: vars.$x480) {
		margin-bottom: 1.2rem;
	}
}

.service-notice__btn {
	padding: 0 1.6rem;
	@media (max-width: vars.$x480) {
		// в макете текст кнопки занимает почти всю ширину: отступы 0.6rem, на узких экранах — перенос
		padding: 0.8rem 0.6rem;
		font-size: 2rem;
		min-height: 4.8rem;
		border-radius: 1.6rem;
		white-space: normal;
		text-align: center;
	}
}
</style>
